module.exports = __webpack_public_path__ + "static/media/tyre-red-two5.a8993d33.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/tyre-red-two5.png
// module id = 84
// module chunks = 0